import React, { Component } from "react";
import { Row, Col } from "antd";
import { COL_1_LINKS, COL_2_LINKS, SOCIAL_LINKS } from "utils/footerLinks";
import { RightOutlined } from "@ant-design/icons";
import "assets/stylesheets/Footer.scss";

export default class Footer extends Component {
  scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <footer className="footer-container">
        <div onClick={this.scrollToTop} className="desktop-only ">
          <button className="desktop-back-to-top">
            <div className="back-to-top vertical-rotate ">
              <div style={{ marginRight: 20 }}>Back to top</div>
              <RightOutlined />
            </div>
          </button>
        </div>
        <div className="footer-green-line desktop-only" />
        <div className="footer-content-container">
          <button
            onClick={this.scrollToTop}
            className="mobile-only footer-col mobile-back-to-top"
          >
            <div className="flex-align-items-center">
              <img src={"images/Back-Top-Arrow.svg"} alt="" />
              <div className="back-to-top">Back to top</div>
            </div>
          </button>
          <Row>
            <Col className="footer-col" xs={24} sm={24} md={24} lg={24} xl={8}>
              <ul>
                {COL_1_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      className="footer-link"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
            <Col className="footer-col" xs={24} sm={24} md={24} lg={24} xl={4}>
              <ul>
                {COL_2_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      className="footer-link"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
            <Col
              className="footer-col"
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={6}
            />
            <Col className="footer-col" xs={24} sm={24} md={24} lg={24} xl={6}>
              <div className="footer-social-container">
                <h2 className="footer-social-title">Follow Us</h2>
                <div className="footer-social-icons-container">
                  <ul>
                    {SOCIAL_LINKS.map((link) => (
                      <li key={link.name}>
                        <a
                          aria-label={link.name}
                          className="footer-social-icon"
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.icon}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>

            <Col className="footer-col" span={24}>
              <p className="footer-copyright">
                &copy; {new Date().getFullYear()} Universities Admissions Centre
                (NSW & ACT) Pty Ltd ACN 070 055 935 ABN 19 070 055 935
              </p>
            </Col>
          </Row>
        </div>
      </footer>
    );
  }
}
